import axios from "axios";

// Same origin by default: on Render the backend serves the site and the API
// together. Set REACT_APP_BACKEND_URL only to point at a backend elsewhere.
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "btb-admin-token";
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);
const authHeader = () => {
  const t = getToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
};

export const submitWalkthrough = async (payload) => {
  const { data } = await axios.post(`${API}/walkthrough`, payload);
  return data;
};

export const submitPlaybook = async (payload) => {
  const { data } = await axios.post(`${API}/playbook-request`, payload);
  return data;
};

export const adminLogin = async (email, password) => {
  const { data } = await axios.post(`${API}/auth/login`, { email, password });
  setToken(data.access_token);
  return data.user;
};

export const fetchMe = async () => {
  const { data } = await axios.get(`${API}/auth/me`, { headers: authHeader() });
  return data;
};

export const fetchWalkthroughs = async () => {
  const { data } = await axios.get(`${API}/walkthrough`, { headers: authHeader() });
  return data;
};

export const fetchPlaybookRequests = async () => {
  const { data } = await axios.get(`${API}/playbook-request`, { headers: authHeader() });
  return data;
};

export const submitResourceRequest = async (payload) => {
  const { data } = await axios.post(`${API}/resource-request`, payload);
  return data;
};

export const fetchResourceRequests = async () => {
  const { data } = await axios.get(`${API}/resource-request`, { headers: authHeader() });
  return data;
};

export const importFromOldSite = async (email, password, sourceUrl) => {
  const { data } = await axios.post(
    `${API}/admin/import-old-site`,
    { email, password, ...(sourceUrl ? { source_url: sourceUrl } : {}) },
    { headers: authHeader() },
  );
  return data;
};
